export const bp = (window.bp = window.bp || {});

// We don't wan't ajax requests to be cached
$.ajaxSetup({cache: false});
